import { render, staticRenderFns } from "./SqlCode.vue?vue&type=template&id=60ddef60&scoped=true"
import script from "./SqlCode.vue?vue&type=script&lang=js"
export * from "./SqlCode.vue?vue&type=script&lang=js"
import style0 from "./SqlCode.vue?vue&type=style&index=0&id=60ddef60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddef60",
  null
  
)

export default component.exports